import FilterFormContextProvider from 'components/filters/FilterFormContextProvider';
import { Outlet } from 'react-router-dom';
import MessageLogTabHeader from './header/MessageLogTabHeader';
import MessageLogTable from './table/MessageLogTable';
import {
  getFormDefaultValues,
  messageLogTabFiltersSchema,
} from './filters/MessageLogTabFilters.schema';
import { MESSAGE_LOG_TAB_FILTERS_LOCAL_STORAGE_KEY_PREFIX } from './filters/MessageLogTabFilters.constants';
import MessageLogTabFilters from './filters/MessageLogTabFilters';

const MessageLogTab = () => {
  return (
    <FilterFormContextProvider
      defaultValues={getFormDefaultValues()}
      localStorageKeyPrefix={MESSAGE_LOG_TAB_FILTERS_LOCAL_STORAGE_KEY_PREFIX}
      schema={messageLogTabFiltersSchema()}
    >
      <MessageLogTabHeader>
        <MessageLogTabFilters />
      </MessageLogTabHeader>
      <MessageLogTable />
      <Outlet />
    </FilterFormContextProvider>
  );
};

export default MessageLogTab;
